import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Title from "../Typography/Title";
import SwiperCard from "./SwipperCard";
import { useRef } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import ignition from "../images/ignition.jpeg"; // You can use different images for each testimonial if desired.
import jdsexports from "../images/jdsexports.jpg";
import aptto from "../images/aptto.jpg";
import thegiftrajastudio from "../images/thegiftrajastudio.jpg"
const testimonials = [
  {
    title: "I have a good experience with working with you.",
    content:
      "Your service and pricing are good and also I have a doubt or a problem                                     if I message they will suddenly reply and solve that problem                                                      that what I like the most. Overall they are good agency and                                                          i have a great experience with them keep going",
    name: "Nikhil",
    company: "Ignition",
    user: ignition,
  },
  {
    title: "I need to tell about our website really it was awesome work bro !",
    content:
      "Hiii ,good morning brother ✨It’s very user friendly what I expected it there And thank you so much ZENHOOK TEAM and fakir bro thank you so much One more i wish you and u r team to reach your goals.keep going keep rocking. All the very best ",
    name: "Mithun Balaji",
    company: "The gift raja studio",
    user: thegiftrajastudio,
  },
  {
    title: "Grateful and Inspired by Your Dedication",
    content:
      "Without out your dedication and fast work nature turns my dream comes true I am very happy and satisfied with your work keep inspire many like this may Allah bless u always.. Alhamdulillah for everything.",
    name: "Amanullah",
    company: "Aptto",
    user: aptto,
  },
  {
    title: "Thank you, Team, for creating our website!",
    content:
      "Hello Team, Thank you so much for created our website. I'm really Happy with your service, Overall our Website is great, . Thanks for bringing this as per our expectations. Good Job guys!!",
    name: "Smith",
    company: "Jds international exports",
    user: jdsexports,
  },
];

function ContentSegment() {
  const swiperRef = useRef(null); // Ref to access the Swiper instance

  return (
    <section className="w-full h-[600px] relative my-36">
      <div className="rounded-[100px] flex items-center justify-center top-0 left-full bg-gradient-to-r rotate-90 from-[#00c3ffdb] to-[#FF29C3] absolute h-72 w-72 blur-[100px] z-0"></div>
      <div className="text-center m-auto">
        <Title
          title={"Customer is Our Top Priority"}
          miniTitle={"Testimonial"}
        />
        <p className="md:w-[400px] w-[98%] m-auto mt-3 md:text-xl font-light text-neutral-500">
          We survey all our clients, the results of which go directly to our CEO
        </p>
      </div>
      <div className="w-full flex items-center justify-center mt-5 relative">
        <Swiper
          ref={swiperRef}
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          className="w-full"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <SwiperCard
                title={testimonial.title}
                testimonial={{
                  title: testimonial.title,
                  content: testimonial.content,
                }}
                name={testimonial.name}
                company={testimonial.company}
                user={testimonial.user}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* Navigation Buttons */}{" "}
      <button
        onClick={() => swiperRef.current.swiper.slidePrev()}
        className="bg-[#ffffff16] absolute md:top-[350px] top-[102%] md:max-w-20 left-[10%] md:left-7 z-10  h-14 text-white py-2 px-4 rounded-full hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] transition"
      >
        <MdArrowForwardIos size={24} className="rotate-180" />
      </button>
      <button
        onClick={() => swiperRef.current.swiper.slideNext()}
        className="bg-[#ffffff16] absolute md:top-[350px] top-[102%] md:max-w-20 right-[10%] z-10 md:right-7 h-14 rounded-full text-white py-2 px-4 hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] transition"
      >
        <MdArrowForwardIos size={24} />
      </button>
    </section>
  );
}

export default ContentSegment;

//      {/* Navigation Buttons */}
//      <button
//      onClick={() => swiperRef.current.swiper.slidePrev()}
//      className="absolute md:top-[220px] top-[88%] md:max-w-20 left-[10%] md:left-7 transform -translate-y-1/2 bg-white bg-opacity-30 backdrop-blur-md text-gray-700 rounded-full p-2 md:p-4 shadow-lg hover:bg-opacity-50 transition"
//    >
//    </button>

//    <button
//      onClick={() => swiperRef.current.swiper.slideNext()}
//      className="absolute md:top-[220px] top-[88%] md:max-w-20 right-[10%] md:right-7 transform -translate-y-1/2 bg-white bg-opacity-30 backdrop-blur-md text-gray-700 rounded-full p-2 md:p-4 shadow-lg hover:bg-opacity-50 transition"
//    >
//    </button>
//  </div>
